import { BotFlow } from '@feedyou/schema'
import { APPLY_DIFF } from '../../../constants/actionTypes'

export function applyDiff(originalVersion: BotFlow, diff: string | undefined) {
  return { type: APPLY_DIFF, payload: { diff, originalVersion } }
}
